// Central place for runtime env. Everything is read once at module load — Vite
// inlines these at build time so callers get a plain string / boolean.

export const API_BASE: string =
  (import.meta.env.VITE_API_BASE as string | undefined) ?? '/api'

export const CABINET_URL: string =
  (import.meta.env.VITE_CABINET_URL as string | undefined) ?? 'http://localhost:5173'

// SPEC-056 is Phase 4 / P2. Gate at the client so the button doesn't appear
// until the backend is confirmed to return `replacement_text`.
export const COUNTER_EDITS_ENABLED: boolean =
  (import.meta.env.VITE_ENABLE_COUNTER_EDITS as string | undefined) === 'true'

// sessionStorage key. Same shape as cabinet (SPEC-015) but different key so the
// two apps don't stomp on each other when opened in the same browser session
// during dev.
export const TOKEN_KEY = 'juniverso_addin_tenant_token'
